export default __webpack_public_path__ + "ba7e87dc13ab29fda8c2f3d5c8255e86.svg";